import { render } from "./ViewHome.vue?vue&type=template&id=1d37495b"
import script from "./ViewHome.vue?vue&type=script&lang=ts"
export * from "./ViewHome.vue?vue&type=script&lang=ts"

import "./ViewHome.vue?vue&type=style&index=0&id=1d37495b&lang=scss"
script.render = render

export default script